export const SET_CATEGORIES_MARKETPLACE = "SET_CATEGORIES_MARKETPLACE";
export const SET_CATEGORIES_BENEFITS_MARKETPLACE = "SET_CATEGORIES_BENEFITS_MARKETPLACE";
export const SET_CATEGORY_TYPE_MARKETPLACE = "SET_CATEGORY_TYPE_MARKETPLACE";
export const SET_SUBCATEGORIES_MARKETPLACE = "SET_SUBCATEGORIES_MARKETPLACE";
export const SET_MODO_MARKETPLACE = "SET_MODO_MARKETPLACE"; 
export const SET_CATEGORIES_ID_MARKETPLACE = "SET_CATEGORIES_ID_MARKETPLACE";
